import { render, staticRenderFns } from "./GalleryCameraRoll.vue?vue&type=template&id=125e3ae8&scoped=true"
import script from "./GalleryCameraRoll.vue?vue&type=script&lang=js"
export * from "./GalleryCameraRoll.vue?vue&type=script&lang=js"
import style0 from "./GalleryCameraRoll.scss?vue&type=style&index=0&id=125e3ae8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e3ae8",
  null
  
)

export default component.exports